module.exports = {
  path: 'information',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CompanyInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/companies/routes/show/routes/information/index.js